import { GlobalStyles,TextField } from "@mui/material";
import { useEffect,useRef,useState } from "react";
import { useTranslation } from "react-i18next";
import { trackEventMatomo } from "../../../helpers/matomo";
import { googleMapsService } from "../../../service/Google";
import { PlaceType } from "../../../types/places/types";

const PlacesAutocomplete = ({
  place,
  setPlace
}: {
  place: PlaceType | null,
  setPlace: Function
}) => {
  const inputRef = useRef(null);
  const { t } = useTranslation('translation');
  const [localInput, setLocalInput] = useState('');

  useEffect(() => {
    if (!inputRef.current) return;

    googleMapsService.createAutocomplete(
      inputRef.current,
      (place) => {
        setPlace((prev: PlaceType) => prev
          ? {
            ...prev,
            lat: place.geometry?.location?.lat() || 0,
            lng: place.geometry?.location?.lng() || 0,
            localizacao: place.formatted_address || ''
          }
          : null);
        setLocalInput(place.formatted_address || '');
        trackEventMatomo('modal de autocomplete local', 'click', 'input', 'seleciona endereço');
      }
    );
  }, [setPlace]);

  useEffect(() => {
    setLocalInput(place?.localizacao || '');
  }, [place]);



  return (
    <>
      <GlobalStyles
        styles={{
          '.pac-container': {
            zIndex: 2000,
          },
        }}
      />
      <TextField
        inputRef={inputRef}
        label={t('address')}
        fullWidth
        value={localInput}
        onChange={(eve) => {
          trackEventMatomo('modal de autocomplete local', 'click', 'input', 'edita valor');
          setLocalInput(eve.target.value);
        }}
      />
    </>
  );
};

export default PlacesAutocomplete;